const Lang = require('lang');

exports.confirmation = {
  OK: Lang.get('js/src/helpers/bootboxConfig.ok'),
  CANCEL: Lang.get('js/src/helpers/bootboxConfig.cancel'),
  CONFIRM: Lang.get('js/src/helpers/bootboxConfig.confirm'),
};

exports.deletion = {
  OK: Lang.get('js/src/helpers/bootboxConfig.ok'),
  CANCEL: Lang.get('js/src/helpers/bootboxConfig.cancel'),
  CONFIRM: Lang.get('js/src/helpers/bootboxConfig.confirm'),
};

exports.delete = {
  OK: Lang.get('js/src/helpers/bootboxConfig.ok'),
  CANCEL: Lang.get('js/src/helpers/bootboxConfig.cancel'),
  CONFIRM: Lang.get('js/src/helpers/bootboxConfig.confirm'),
};

exports.defaults = {
  locale: Lang.get('js/src/helpers/bootboxConfig.locale')
};
